import { StyleSheet, ViewProps } from 'react-native'
import { BreadcrumbData } from 'zens-storybook'
import { useCompany, useLocation } from 'zens-store'
import { useBreadcrumb } from '@dms/hook'

import { LayoutHeader } from '../layout'

const styles = StyleSheet.create({
  container: {},
})

interface Props extends ViewProps {
  companyId: number
  locationId: number
  breadcrumbItems?: BreadcrumbData[]
}

const LocationHeader = (props: Props) => {
  const { companyId, locationId, breadcrumbItems, style, ...otherProps } = props
  const company = useCompany({ companyId })
  const location = useLocation({ companyId, locationId })

  const breadcrumb = useBreadcrumb([
    {
      title: company.data?.name || '',
      href: `/companies/${companyId}/detail`,
    },
    {
      title: location.data?.name || '',
      href: `/companies/${companyId}/locations/${locationId}`,
    },
    ...(breadcrumbItems || []),
  ])
  return (
    <LayoutHeader
      breadcrumb={breadcrumb}
      title={location.data?.name || ' '}
      style={[styles.container, style]}
      {...otherProps}
    />
  )
}

export default LocationHeader
